module.exports = __webpack_public_path__ + "static/media/backdrop-clipped.c178aab0.jpg";